import React from "react"

import { StaticImage } from "gatsby-plugin-image"


import Seo from "../components/SEO"
import "../styles/new.css"
import "../styles/mobilenew.css"
import im1 from "../images/expph/lady1.jpg"

const AboutPage = () => {



  return (

    <>
      <Seo
        title="About"
        description="Nolan Interiors is the leading luxury interior design firm in uk."
        image={im1}
      />


      <div className="section flexthis">
        <div className="flex5 aboutimage maxdim">
          <StaticImage placeholder="dominantColor" objectFit="contain" className="image" src="../images/expph/l2.jpg" alt="lady" />
        </div>

        <div className="flex3 centerthis designimage">
          <article className="article">
            <h3>About Me</h3>
            <p>Stacy Nolan has been running her own design firm for almost 27 years.
              The studio focuses on residential and commercial design, primarily in
              London but also internationally. Her art has been featured in the British
              press several times. Stacy has a degree in architecture.
              Stacy specialises in curating unique rooms with an eye for colour and size,
              merging antique and modern elements of style in a way that is both current
              and timeless. Her style is influenced by the depth and diversity of her background.</p>
          </article>
        </div>

      </div>





      <div className="section flexthis">

        <div className="flex7 centerthis servicesmobile">
          <article className="article">
            <h3>My Team</h3>
            <p>Meet Frenchie and Shaggy, my charming little pals who assist me with my
              work and keep the workplace bright and cheery. Pets provide so much happiness
              to a family's life. Frenchie and Shaggy always remind me to focus not just on
              beautiful homes, but also on functionality for busy families, especially those with pets.</p>
          </article>
        </div>

        <div className="flex5">
          <StaticImage placeholder="dominantColor" className="image" src="../images/expph/dogo.jpg" alt="lady1" />
        </div>

      </div>


      <div className="section">

        <h3 className="centerthis">DESIGN PHILOSOPHY</h3>

        <div className="designflex">
          <div className="philosophygrid">
            <div>
              {/* <!--blank space--> */}
            </div>
            <div className="centerthis">
              <p className="article">I work hard to design thoughtful interiors that excite and inspire
                you on a daily basis, and I travel the world in search of the most unusual and beautiful objects
                for you to enjoy for a lifetime.</p>
            </div>
            <div className="black margintopbottom">
              {/* <!--horizontal line--> */}
            </div>
            <div className="centerthis">
              <p className="article">I offer a single professional service that combines planning, architecture,
                landscape architecture, and interior design to create holistic environments that protect natural
                resources, add value to clients, and build long-lasting communities.</p>
            </div>
            <div>
              {/* <!--blank space--> */}
            </div>

          </div>


          <StaticImage placeholder="dominantColor" className="image halfdim designimage" src="../images/expph/phil1.jpg" alt="phil2" />

        </div>

        <div className="designflex">
          <div className="philosophygrid">
            <div>
              {/* <!--blank space--> */}
            </div>
            <div className="centerthis">
              <p className="article">Our environments have the power to change people's lives. I create surroundings
                that are unique and ageless, stimulating all of the senses, by going beyond trend. I comprehend a
                project's ultimate essence, which reveals the true design storey.</p>
            </div>
            <div className="black margintopbottom">
              {/* <!--horizontal line--> */}
            </div>
            <div className="centerthis">
              <p className="article">My vision is ambitious, far-ranging and constantly innovating. Guided by clear style
                principles yet unfettered by a house ‘style’, I always see beyond the bounds of a brief to discover
                surprising and inspiring possibilities.</p>
            </div>
            <div>
              {/* <!--blank space--> */}
            </div>

          </div>


          <StaticImage placeholder="dominantColor" className="image halfdim designimage" src="../images/expph/phil2.jpg" alt="phil2" />

        </div>
      </div>

      {/* footer */}

      <div className="section flexthis">

        <div className="">
          <StaticImage placeholder="dominantColor" className="image contact" src="../images/expph/pic8.jpg" alt="herolp" />
        </div>

        <div className="centerthis servicesmobile mobilemargins">
          <article className="article">
            <h3>I WOULD LOVE <br />TO TALK </h3>
            <p>Want to talk with me about designing your home? Ah-mazing. I totally want to talk to YOU. Drop us a line!</p>

            <h3><a href="mailto:hello@nolaninteriors.com">hello@nolaninteriors.com</a></h3>
            
            <form action="">
              <input type="text" placeholder="NAME" />
              <input type="text" placeholder="EMAIL" />
              <input type="text" placeholder="CONTACT NO." />
              <input type="text" placeholder="REFERENCE" />
              <textarea name="" id="" cols="30" rows="10" />
              <button className="button">SUBMIT</button>
            </form>

            <div className="flexthis">
              <a href="https://facebook.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                className="button centerthis">facebook</a>
              <a href="https://www.instagram.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                className="button centerthis">instagram</a>
              <a href="https://pinterest.com/nolaninteriors/" target="_blank" rel="noopener noreferrer"
                className="button centerthis">pinterest</a>
              <a href="https://www.houzz.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                className="button centerthis">houzz</a>
            </div>

            <div className="flexthis">
              <a href="https://asteriasoft.studio" target="_blank" rel="noopener noreferrer"
                className="button centerthis">Website by Asteriasoft</a>
            </div>
          </article>
        </div>
      </div>



    </>

  )
}

export default AboutPage







